import { InputField, LabelTextWrapper } from "./styled";

type InputLabelCheckboxProps = {
  disabled?: boolean;
  labelText: string;
  labelId: string;
  checked?: boolean;
  onChange?: (value: boolean) => void;
  tooltipText?: string;
  required?: boolean;
  column?: boolean;
};

function InputLabelCheckBox({
  labelText,
  tooltipText,
  disabled,
  labelId,
  checked,
  onChange,
  column,
}: InputLabelCheckboxProps) {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (onChange) {
      onChange(checked);
    }
  };

  return (
    <InputField
      title={tooltipText}
      className={column ? "columnFormField fieldchckbx" : "fieldchckbx"}
      htmlFor={labelId}
    >
      <input
        name={labelId}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={onChangeHandler}
      />

      <LabelTextWrapper className="inpcheckbox">{labelText}</LabelTextWrapper>
    </InputField>
  );
}

export default InputLabelCheckBox;
